import MediaConfig from "./MediaConfig";

export default class MediaService {
    static uploadFile(file, path, type) {
        return new Promise(async (resolve, reject) => {
            try {
                await MediaConfig.FirebaseConnector.uploadFile(
                    file,
                    path,
                    type,
                    async (downloadURL, path, filename) => {
                        resolve({downloadURL, path, filename})
                        /*INIT_INJECT_API_REST_MEDIA_SERVICE*/
                    }
                );
            } catch (e) {
                reject(e);
            }
        });
    }
    static downloadFile(filePath) {
        return new Promise(async (resolve, reject) => {
            try {
                let response = await MediaConfig.FirebaseConnector.downloadFile(
                    filePath
                );
                resolve(response);
            } catch (error) {
                reject(error);
            }
        });
    }

    static deleteFile(filePath){
      return new Promise(async (resolve, reject) => {
        try {
          MediaConfig.FirebaseConnector.deleteFile(filePath,(r)=>{
            resolve(r);
          });
          
        } catch (error) {
          reject(error);
        }
      })
    }
}



// WEBPACK FOOTER //
// ./src/provider/media/MediaService.js